import {
  getTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPost,
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostData,
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { queryClient } from '@common/config/api/queryClient'
import { queryKeyFactory } from '@features/study_details/Subjects/queryKeyFactory'
export const useTimepointExamReassignementEsignMutation = (): UseMutationResult<
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostResponse,
  AxiosError<HTTPValidationError>,
  GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostData
> => {
  return useMutation<
    GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostResponse,
    AxiosError<HTTPValidationError>,
    GetTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPostData
  >({
    mutationFn: async (query) => {
      const response =
        await getTimepointExamReassignmentEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdExamReassignEsignPost(
          {
            path: query.path,
            body: query.body,
            throwOnError: true,
          },
        )
      return response.data
    },
    onSuccess: (_, query) => {
      queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
      queryClient.invalidateQueries({
        queryKey: queryKeyFactory.subjectTimepoints({
          study_id: query.path.study_id,
          subject_id: query.path.subject_id,
        }),
      })
      queryClient.invalidateQueries({ queryKey: ['TimePointsDetails'] })
      queryClient.invalidateQueries({ queryKey: ['TimepointExamReassignementCheck'] })
    },
  })
}
